@if (shouldHaveSeparateNewButtons()) {
    @if (viewStateLoaded()) {
        <mat-button-toggle-group class="st-playbook-main-cta-button-group">
            <mat-button-toggle
                class="st-playbook-main-cta-button-new-topic"
                [class.st-playbook-main-cta-button-new-topic__disabled]="!topicEditable"
                [disabled]="!topicEditable"
                (click)="onNewTopicClicked()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                {{ languageSettings.PSTObjectTypeTopic }}
            </mat-button-toggle>
            <mat-button-toggle
                mat-icon-button
                class="st-playbook-main-cta-button-new-topic-template"
                [class.st-playbook-main-cta-button-new-topic-template__disabled]="!topicEditable"
                [matMenuTriggerFor]="topicTemplateMenu"
                [disabled]="topicTemplatesDisabled()"
                (menuOpened)="onTopicTemplateMenuOpened()">
                <mat-icon>arrow_drop_down</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-button-toggle-group class="st-playbook-main-cta-button-group">
            <mat-button-toggle
                class="st-playbook-main-cta-button-new-story"
                [class.st-playbook-main-cta-button-new-story__disabled]="!storyEditable"
                [disabled]="!storyEditable"
                (click)="onNewStoryClicked()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                {{ languageSettings.PSTObjectTypeStory }}
            </mat-button-toggle>
            <mat-button-toggle
                mat-icon-button
                class="st-playbook-main-cta-button-new-story-template"
                [class.st-playbook-main-cta-button-new-story-template__disabled]="!storyEditable"
                [matMenuTriggerFor]="storyTemplateMenu"
                [disabled]="storyTemplatesDisabled()"
                (menuOpened)="onStoryTemplateMenuOpened()">
                <mat-icon>arrow_drop_down</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    }
} @else {
    @if (viewStateLoaded()) {
        <button
            class="st-playbook-main-cta-button-new-topic__combined"
            mat-icon-button
            [disabled]="!topicEditable"
            [matMenuTriggerFor]="menu">
            <mat-icon class="material-symbols-outlined">add</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <ng-template matMenuContent>
                <button
                    mat-menu-item
                    (click)="onNewTopicClicked()">
                    {{ languageSettings.PSTWebNewLabel }}
                </button>
                @if (topicTemplates().length > 0) {
                    <button
                        mat-menu-item
                        [matMenuTriggerFor]="topicTemplateMenu"
                        (menuOpened)="onTopicTemplateMenuOpened()">
                        {{ languageSettings.PSTWebTemplateLabel }}
                    </button>
                }
            </ng-template>
        </mat-menu>
    }
}

<mat-menu
    #topicTemplateMenu="matMenu"
    class="st-playbook-main-cta-templates-menu">
    @if (topicTemplates().length > 0) {
        <ng-template matMenuContent>
            @for (item of topicTemplates(); track item?.Guid) {
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false">
                    <mat-list-option
                        [value]="item?.Title"
                        [disabled]="item?.isDeleted"
                        (click)="selectTopicTemplate(item)">
                        <div
                            matListItemTitle
                            class="st-playbook-main-cta-button-new-topic-template__title"
                            [dir]="directionality()">
                            <span>{{ item?.Title }}</span>
                            <button
                                mat-icon-button
                                matListItemMeta
                                st-click-stop-propagation
                                class="st-playbook-main-cta-button-new-topic-template__delete-button"
                                [disabled]="item?.isDeleted"
                                (click)="deleteTemplate(item)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            }
        </ng-template>
    }
</mat-menu>

<mat-menu
    #storyTemplateMenu="matMenu"
    class="st-playbook-main-cta-templates-menu">
    @if (storyTemplates().length > 0) {
        <ng-template matMenuContent>
            @for (item of storyTemplates(); track item?.Guid) {
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false">
                    <mat-list-option
                        class="st-playbook-main-cta-button-new-story-template"
                        [value]="item?.Title"
                        [disabled]="item?.isDeleted"
                        (click)="selectStoryTemplate(item)">
                        <div
                            matListItemTitle
                            class="st-playbook-main-cta-button-new-story-template__title"
                            [dir]="directionality()">
                            <span>{{ item?.Title }}</span>
                            @if (item?.Guid !== optionBlank) {
                                <button
                                    mat-icon-button
                                    matListItemMeta
                                    st-click-stop-propagation
                                    [disabled]="item?.isDeleted"
                                    (click)="deleteTemplate(item)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            }
        </ng-template>
    }
</mat-menu>
